import  { useState, useEffect } from 'react'
import { toast, Toast } from '../../lib/toast'
import styles from './ToastContainer.module.css'

export default function ToastContainer() {
  const [toasts, setToasts] = useState<Toast[]>([])

  useEffect(() => {
    return toast.subscribe(setToasts)
  }, [])

  return (
    <div className={styles.container}>
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`${styles.toast} ${styles[t.type]}`}
          onClick={() => toast.remove(t.id)}
        >
          <div className={styles.message}>{t.message}</div>
          <button className={styles.close} onClick={() => toast.remove(t.id)}>
            ×
          </button>
        </div>
      ))}
    </div>
  )
}